import PageMeta from '@/components/feature/PageMeta';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import Benefits from './components/Benefits';
import FeaturedGuides from './components/FeaturedGuides';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { faqItems } from '@/mocks/faq';

const homeTitle = 'LitBuy Spreadsheet Guides & Tracking Resources (2026)';
const homeDescription = 'Learn how to create, organize, and optimize a LitBuy spreadsheet with comprehensive guides, templates, tracking methods, and expert tips. Independent educational resource for spreadsheet management.';
const homePath = '/';

const homeJsonLd = (siteUrl: string) => ({
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: 'LitBuy Spreadsheets',
      url: siteUrl,
      description: homeDescription,
    },
    {
      '@type': 'WebSite',
      name: 'LitBuy Spreadsheets',
      url: siteUrl,
      description: homeDescription,
      publisher: {
        '@type': 'Organization',
        name: 'LitBuy Spreadsheets',
      },
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${siteUrl}/search?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    },
  ],
});

export default function Home() {
  return (
    <>
      <PageMeta title={homeTitle} description={homeDescription} path={homePath} ogType="website" jsonLd={homeJsonLd} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <Benefits />
        <FeaturedGuides />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}